import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Orderinfo.vue',
  data() {
    return {
      mergedData: [],
      // 存储合并后的数据
      currentPage: 1,
      total: 0,
      pageSize: 10,
      pageSizes: [10, 15, 20, 25, 30],
      currentPageData: [] // 当前页的数据
    };
  },

  created() {
    this.load(); // 默认加载合并后的数据
  },

  methods: {
    // 时间格式化
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    // 加载数据
    load() {
      request.get('/alipay/queryList').then(res => {
        const orders = res || [];
        this.loadBalanceDetails(orders); // 加载余额明细并合并数据
      });
    },

    // 加载余额明细数据并合并
    loadBalanceDetails(orders) {
      request.get('/alipay/queryList1').then(res => {
        const balances = res || [];

        // 合并订单数据和余额数据
        const mergedData = [...orders.map(order => ({
          tradeNo: order.tradeNo,
          orderAmount: order.orderAmount,
          tradeStatus: order.tradeStatus || '已支付',
          // 如果没有支付状态则设置为已支付
          type: order.type,
          createDate: order.createDate
        })), ...balances.map(balance => ({
          tradeNo: balance.traceNum,
          orderAmount: balance.money,
          tradeStatus: '已支付',
          // 余额明细默认已支付
          type: balance.type,
          createDate: balance.createDate
        }))];

        // 根据支付时间排序，确保最新的数据排在前面
        mergedData.sort((a, b) => new Date(b.createDate) - new Date(a.createDate));

        // 为所有数据重新生成订单编号（从1开始）
        this.mergedData = mergedData.map((item, index) => ({
          ...item,
          orderId: index + 1 // 从1开始编号
        }));

        this.total = this.mergedData.length;
        this.getPageInfo(); // 根据当前分页设置数据
      });
    },

    // 获取当前页的数据
    getPageInfo() {
      this.currentPageData = [];
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        this.currentPageData.push(this.mergedData[i]);
        if (this.currentPageData.length === this.pageSize) break;
      }
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPageInfo();
    },
    // 每页显示条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageInfo();
    },
    // 重新支付
    rePay(orderInfo) {
      request.post('/alipay/order2', orderInfo).then(res => {
        console.log(res);
        if (res.code === '0' && res.data) {
          const paymentForm = res.data;
          const formContainer = document.createElement('div');
          formContainer.innerHTML = paymentForm;
          document.body.appendChild(formContainer);
          const formElement = formContainer.querySelector('form');
          if (formElement) {
            formElement.submit();
          } else {
            alert('支付表单未找到');
          }
        } else {
          alert('支付请求失败');
        }
      }).catch(error => {
        console.error(error);
        alert('支付请求出错');
      });
    }
  }
};